import React from "react";
import CallCenterModal from "../call-center/listing/CallCenterModal";

const OrganizationConfigModal = ({
  open,
  title,
  subtitle,
  organizationCode,
  onClose,
  disabled = false,
  closeLabel,
  loading = false,
  children,
}) => (
  <CallCenterModal
    open={open}
    onClose={onClose}
    blockClose={disabled}
    eyebrow={title}
    title={subtitle}
    badges={organizationCode ? [organizationCode] : []}
    maxWidth="5xl"
    maxHeight="min(92vh,900px)"
    zIndexClass="z-[190]"
    closeLabel={closeLabel}
    loading={loading}
    contentVariant="card"
    footer={
      <button
        type="button"
        onClick={onClose}
        disabled={disabled}
        className="h-10 rounded-xl border border-slate-200 px-5 text-sm font-semibold text-slate-600 transition hover:bg-slate-50 disabled:opacity-50"
      >
        {closeLabel}
      </button>
    }
  >
    {children}
  </CallCenterModal>
);

export default OrganizationConfigModal;
